module.exports = {
          srcSet: "/_next/static/images/img-mobilier@2x-200-0825ad25a62e3ec1017843b25b3458d8.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-mobilier@2x-200-0825ad25a62e3ec1017843b25b3458d8.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-mobilier@2x-200-0825ad25a62e3ec1017843b25b3458d8.jpg",
          toString:function(){return "/_next/static/images/img-mobilier@2x-200-0825ad25a62e3ec1017843b25b3458d8.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }